(() => {
  'use strict';

  const drawerSelector = '#menu-drawer';
  const blockId = 'gowin-menu-discovery';

  const secondaryPaths = new Set([
    '/collections/ofertas',
    '/collections/todos-los-productos',
    '/collections/packs-de-geles-y-carbohidratos-para-running-ciclismo-y-triatlon-en-costa-rica',
    '/blogs/noticias',
  ]);

  const brands = [
    {
      label: 'Carlyle',
      href: '/collections/carlyle-nutritionals',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/Carlyle-nutritional-suplementos-costa-rica.webp?v=1785564770',
    },
    {
      label: 'Maurten',
      href: '/collections/maurten',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/Maurten-Geles.webp?v=1785557122',
    },
    {
      label: 'SiS',
      href: '/collections/sis-science-in-sport',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/SIS-_Science_Sport.webp?v=1785561898',
    },
    {
      label: 'NatureWise',
      href: '/collections/natural-wise',
      image: 'https://cdn.shopify.com/s/files/1/0970/7234/9549/collections/NaturalWise.webp?v=1785565852',
    },
  ];

  const shortcuts = [
    { label: 'Ver ofertas', href: '/collections/ofertas', primary: true },
    { label: 'Todos los productos', href: '/collections/todos-los-productos' },
    {
      label: 'Packs deportivos',
      href: '/collections/packs-de-geles-y-carbohidratos-para-running-ciclismo-y-triatlon-en-costa-rica',
    },
    { label: 'Blog y consejos', href: '/blogs/noticias' },
  ];

  const pathOf = (value) => {
    try {
      const path = new URL(value, window.location.origin).pathname;
      return path.length > 1 ? path.replace(/\/+$/, '') : path;
    } catch {
      return '';
    }
  };

  const heading = (text, className) => {
    const node = document.createElement('h2');
    node.className = className;
    node.textContent = text;
    return node;
  };

  const brandLink = (brand) => {
    const link = document.createElement('a');
    link.className = 'gowin-menu-discovery__brand';
    link.href = brand.href;
    link.setAttribute('role', 'listitem');
    link.setAttribute('aria-label', `Ver productos ${brand.label}`);

    const image = document.createElement('img');
    image.className = 'gowin-menu-discovery__brand-image';
    image.src = brand.image;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';

    const label = document.createElement('span');
    label.className = 'gowin-menu-discovery__brand-label';
    label.textContent = brand.label;

    link.append(image, label);
    return link;
  };

  const shortcutLink = (item) => {
    const link = document.createElement('a');
    link.className = 'gowin-menu-discovery__shortcut';
    if (item.primary) link.classList.add('gowin-menu-discovery__shortcut--primary');
    link.href = item.href;
    link.textContent = item.label;
    return link;
  };

  const createBlock = () => {
    const block = document.createElement('section');
    block.id = blockId;
    block.className = 'gowin-menu-discovery';
    block.setAttribute('aria-label', 'Descubrir GOWin Store');

    const rail = document.createElement('div');
    rail.className = 'gowin-menu-discovery__brands';
    rail.setAttribute('role', 'list');
    brands.forEach((brand) => rail.append(brandLink(brand)));

    const actions = document.createElement('div');
    actions.className = 'gowin-menu-discovery__shortcuts';
    shortcuts.forEach((item) => actions.append(shortcutLink(item)));

    block.append(
      heading('Marcas destacadas', 'gowin-menu-discovery__heading'),
      rail,
      heading('Explorar', 'gowin-menu-discovery__shortcut-heading'),
      actions
    );
    return block;
  };

  const enhanceDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    const navigation = drawer.querySelector('.menu-drawer__navigation');
    const container = drawer.querySelector('.menu-drawer__navigation-container');
    if (!navigation || !container) return;

    const list = Array.from(navigation.children).find(
      (node) => node.tagName === 'UL' && node.classList.contains('menu-drawer__menu')
    );
    if (!list) return;

    Array.from(list.children).forEach((item) => {
      const link = item.firstElementChild;
      if (link?.tagName !== 'A' || !secondaryPaths.has(pathOf(link.href))) return;
      item.hidden = true;
      item.classList.add('gowin-menu-secondary-item');
    });

    if (drawer.querySelector(`#${blockId}`)) return;
    const utility = drawer.querySelector('.menu-drawer__utility-links');
    const block = createBlock();
    utility?.parentElement === container
      ? container.insertBefore(block, utility)
      : container.append(block);
  };

  let scheduled = false;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceDrawer();
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run, { once: true })
    : run();

  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', run);
})();
